<template>
  <PageBanner :obj="obj"></PageBanner>
  <router-view></router-view>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      obj: {
        cn: "海玛产品",
        en: "HAIMA PRODUCTS",
        link: "/news",
        image: "",
        list: [],
      },
    };
  },
  methods: {
    async newsIndex() {
      let res = await service.newsIndex();
      if (res.code == 1) {
        this.obj.cn = res.data.banner.name;
        this.obj.en = res.data.banner.eng_title;
        this.obj.image = this.$baseURL + res.data.banner.thumb;
        this.obj.list = res.data.catlist.map((item, index) => {
          return { ...item, comp: "/news/list" };
        });
      }
    },
  },
  created() {
    this.newsIndex();
  },
};
</script>
